// src/theme/theme.js

// Color Palette
const palette = {
  // Primary Colors
  primary: '#1890ff',
  primaryLight: '#40a9ff',
  primaryDark: '#096dd9',
  
  // Secondary Colors
  secondary: '#722ed1',
  secondaryLight: '#9254de',
  secondaryDark: '#531dab',
  
  // Status Colors
  success: '#52c41a',
  successLight: '#73d13d',
  successDark: '#389e0d',
  
  warning: '#faad14',
  warningLight: '#ffc53d',
  warningDark: '#d48806',
  
  error: '#ff4d4f',
  errorLight: '#ff7875',
  errorDark: '#d9363e',
  
  info: '#1890ff',
  infoLight: '#40a9ff',
  infoDark: '#096dd9',

  // Background Colors
  background: {
    default: '#f0f2f5',
    paper: '#ffffff',
    light: '#fafafa',
    dark: '#141414'
  },

  // Text Colors
  text: {
    primary: 'rgba(0, 0, 0, 0.85)',
    secondary: 'rgba(0, 0, 0, 0.45)',
    disabled: 'rgba(0, 0, 0, 0.25)',
    hint: 'rgba(0, 0, 0, 0.45)',
    inverse: '#ffffff'
  },

  // Border Colors
  border: {
    main: '#d9d9d9',
    light: '#f0f0f0',
    dark: '#595959'
  },

  // Common Colors
  common: {
    white: '#ffffff',
    black: '#000000'
  }
};

// Spacing
const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48
};

// Typography
const typography = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fontSize: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 600
  },
  lineHeight: {
    xs: 1.2,
    sm: 1.4,
    md: 1.6,
    lg: 1.8
  }
};

// Shadows
const shadows = {
  none: 'none',
  xs: '0 2px 8px rgba(0, 0, 0, 0.15)',
  sm: '0 4px 12px rgba(0, 0, 0, 0.15)',
  md: '0 8px 16px rgba(0, 0, 0, 0.15)',
  lg: '0 12px 24px rgba(0, 0, 0, 0.15)',
  xl: '0 16px 32px rgba(0, 0, 0, 0.15)'
};

// Border Radius
const borderRadius = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 12,
  circle: '50%'
};

// Z-index
const zIndex = {
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

// Transitions
const transitions = {
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195
  },
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  }
};

// Breakpoints
const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

const theme = {
  colors: palette,
  spacing,
  typography,
  shadows,
  borderRadius,
  zIndex,
  transitions,
  breakpoints
};

export default theme;
